<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-15 15:08:28
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-02-07 10:45:00
 * @FilePath: /adm.xiangli360.com/src/components/Header.vue
-->
<template>
  <el-header height="auto">
       <div class="header">
      <div class="left-side">
        <el-button
          v-show="businessType"
          class="back-btn"
          @click="handleBack"
          type="primary"
          plain
          round
          >返回</el-button
        >
        <img class="logo" src="~@/assets/logo.png" alt="" />
        <span class="title"><a target="_black">乡村振兴数字化管理平台</a></span>
      </div>
       <div class="line" v-show="businessType"></div>
      <div class="center-side" :class="{ 'no-margin': businessType }">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          :router="true"
          @select="selectMenu"
        >
          <el-menu-item
            v-show="!item.meta.hidden"
            v-for="(item, index) in menus"
            :key="index"
            :index="item.path"
            :class="{ 'no-line': businessType }"
            >{{ item.meta.title }}</el-menu-item
          >
        </el-menu>
      </div>
      <div class="right">
        <div class="order">
          <!-- <p>系统设置 &nbsp; |</p> -->
        </div>
       <div class="right-side" @click="handleSignOut">
          <!-- <el-dropdown trigger="click" @command="signOut">
            <span class="el-dropdown-link">
              <label class="fullname">{{ user.fullName }}</label>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- <span class="text">{{ user.fullName }}</span>
          <span class="el-icon-switch-button" @click="signOut">退出</span> -->
          <!-- <img src="@/assets/finance/icon_signOut.png" /> -->
          <p>退出</p>
        </div>
      </div>
    </div>
  </el-header>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      user: null,
      menus: [],
      activeIndex: "",
      businessType: "",
    };
  },
  watch: {
    "$store.state.headMenuPath": {
      handler(val) {
        this.activeIndex = val;
      },
    },
    "$route.query.$businessType": {
      handler(val) {
        this.businessType = val ? val : "";
        this.setMenus();
      },
    },
  },
  created() {
    this.businessType = this.$route.query.$businessType
      ? this.$route.query.$businessType
      : "";
    this.setMenus();
    let user = localStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
    }
    this.setMenus();
  },

  computed: {},
  methods: {
    ...mapActions(["saveHeadMenuPath"]),
    /**
     * @Description: 菜单切换
     * @Author: yangsibo
     * @Date: 2023-01-06 10:38:08
     * @param {*} val
     * @return {*}
     */
    selectMenu(val) {
      this.saveHeadMenuPath(val);
    },
    handleSelect(key, keyPath) {
      // if (!key) {
      //   return;
      // }

      // let path = "";
      // switch (key) {
      //   case "produceServe":
      //     path = "/farming/manage";
      //     break;
      //   case "capital":
      //     path = "/Capital/index";
      //     break;
      //   case "allOrder":
      //     path = "/all-order/capital/list";
      //     this.saveHeadMenuPath(path);
      //     this.activeIndex = path;
      //     break;
      // }
      // this.$router.push({ path: path });
    },
    handleSignOut() {
      localStorage.removeItem("user");
      localStorage.removeItem("loginTime");
      localStorage.removeItem("accessToken");
      this.saveHeadMenuPath("");
      location.reload();
    },
     /**
     * @description: 返回
     * @Author: yangsibo
     * @Date: 2022-06-23 09:08:31
     * @return {*}
     */
    handleBack() {
      this.$router.push({ path: this.$route.query.$backPath, query: {} });
    },
    setMenus() {
      let menuList = this.$router.options.routes.filter((item) => {
        return !item.meta.hidden;
      });
   
      if (
        this.$route.query.$businessType &&
        this.$route.query.$businessType === "_blank"
      ) {
        this.menus = [
          {
            meta: {
              title: this.$route.query.$businessName,
            },
          },
        ];
        this.activeIndex = null;
      } else {
        this.menus = menuList[0].children;
        this.$nextTick(() => {
          this.activeIndex =
            this.$store.state.headMenuPath || this.menus[0].path;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dropdown {
  cursor: pointer;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 4.7vw;
  box-sizing: border-box;
  padding: 0 20px;
  background-color: #018388;
  .left-side {
    display: flex;
    align-items: center;
    .back-btn {
      background: #fff;
      margin-right: 20px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      &:hover,
      &:active,
      &:focus {
        color: #018388 !important;
      }
    }
    .logo {
      width: 1.7vw;
      // height: 2.4vw;
    }
    .title {
      display: inline-block;
      margin-left: 10px;
      color: #fff;
      font-size: 2.1vw;
      font-weight: 900;
      a {
        color: #fff;
      }
    }
  }
  .line {
    width: 40px;
    height: 3px;
    background: #fff;
    margin: 0 10px 0 30px;
  }
  .center-side {
    flex: 1;
    margin-left: 2vw;
    &.no-margin {
      margin-left: 0;
    }
    .el-menu {
      background: none;
      &.el-menu--horizontal {
        border-bottom: none;
      }
      .el-menu-item {
        padding: 0;
        margin: 0 1vw;
        color: #fff;
        font-size: 1.2vw;
        &.is-active {
          border-bottom: 3px solid #fff;
          border-radius: 2px;
        }
        &.no-line {
          border-bottom: none;
        }
        &:not(.is-disabled):hover,
        &:not(.is-disabled):focus {
          background: none;
        }
        a {
          display: block;
          height: 100%;
        }
      }
    }
  }
  .right {
    display: flex;
    .order {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      p {
        color: white;
        margin-left: 5px;
        margin-right: 20px;
        font-size: 18px;
      }
    }
    .right-side {
      display: flex;
      align-items: center;
      cursor: pointer;
      p {
        color: white;
        margin-left: 5px;
        margin-right: 20px;
        font-size: 18px;
      }
      span {
        display: inline-flex;
        align-items: center;
        height: 100%;
        color: #fff;
        font-size: 18px;
        .fullname {
          display: inline-block;
          max-width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .el-icon-switch-button {
        margin-top: 5px;
        cursor: pointer;
        color: #b0eef0;
      }
    }
  }
}
</style>
